import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/calls/voicemail-boxes/$mailboxId/messages/$messageId')({
  staticData: { team: 'fe-phone-experience' },
});
